import { useAtomValue } from 'jotai'
import { draggingCueAtom } from '../store/dnd.store'
import { useMemo } from 'react'
import { useDroppable } from '@dnd-kit/core'
import { DroppableId, CueDropzone } from '../model/dnd'
import type { SortableCue } from '../model/types'

export const useSortableCueDropzone = ({ id, isPartOfGroup }: SortableCue) => {
  const draggingCue = useAtomValue(draggingCueAtom)

  const isDisabled = useMemo(() => {
    const isDraggingGroup = Array.isArray(draggingCue?.children)

    // If dropping a group onto a cue which is part of another group
    if (isDraggingGroup && isPartOfGroup) return true

    return draggingCue?.id === id
  }, [draggingCue?.children, draggingCue?.id, id, isPartOfGroup])

  return useDroppable({
    id: DroppableId[CueDropzone.BEFORE](id),
    disabled: isDisabled,
  })
}
